<template>
    <div>
        <div class="row">
            <div class="col-12">
                <h4>Body</h4>
                <div class="row" v-if="project.scanner == 'api'">
                    <v-jsoneditor ref="editor" v-model="data.body" :options="option" height="400px"></v-jsoneditor>
                </div>
                <div class="row" v-else>
                    <div class="col-md-12">
                        <div class="form-group" v-for="(input, k) in data.body" :key="k">
                            <div class="row">
                                <div class="col-md-6">
                                    <label>Parameter</label>
                                    <input type="text" class="form-control" v-model="data.body[k]['parameter']">
                                </div>
                                <div class="col-md-6">
                                    <label>Value</label>
                                    <input type="text" class="form-control" v-model="data.body[k]['value']">
                                </div>
                            </div>
                            <span>
                                <i class="fas fa-minus-circle text-danger" @click="remove(k)" v-show="k || ( !k && data.body.length > 1)">
                                </i>
                                <i class="fas fa-plus-circle text-success" @click="add(k)" v-show="k == data.body.length-1">
                                </i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <h4>Header</h4>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group" v-for="(input, k) in data.header" :key="k">
                            <div class="row">
                                <div class="col-md-6">
                                    <label>Parameter</label>
                                    <input type="text" class="form-control" v-model="data.header[k]['parameter']">
                                </div>
                                <div class="col-md-6">
                                    <label>Value</label>
                                    <input type="text" class="form-control" v-model="data.header[k]['value']">
                                </div>
                            </div>
                            <span>
                                <i class="fas text-danger fa-minus-circle" @click="remove2(k)" v-show="k || ( !k && data.header.length > 1)">
                                </i>
                                <i class="fas fa-plus-circle text-success" @click="add2(k)" v-show="k == data.header.length-1">
                                </i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VJsoneditor from 'v-jsoneditor/src/index'
export default {
    components: {
        VJsoneditor
    },
    props: ['body', 'header'],
    data() {
        return {
            data: {
                body: [],
                header: [],
            },
            project: {
                scanner: ''
            },
            option: {
                'mode':'code'
            }
        }
    },
    mounted() {
        let me = this;
        this.data.body = this.body;
        this.data.header = this.header;

        this.$axios.get(this.$server + 'organisation/'+ me.$route.params.org_id  + '/project/' + me.$route.params.prod_id)
        .then(res => {
            var r = res.data;
            if (r.success) {
                me.project = r.data[0];
            }
        });
    },

    watch: {
        data: {
            handler: function(val, oldVal) {
                this.$emit('callback', val)
            },
            deep: true
        }
    },

    methods: {
        add(index) {
            this.data.body.push({
                parameter: '',
                value: '',
            });
        },

        remove(index) {
            this.data.body.splice(index, 1);
        },
        add2(index) {
            this.data.header.push({
                parameter: '',
                value: '',
            });
        },

        remove2(index) {
            this.data.header.splice(index, 1);
        },
    }
}
</script>